/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CashExposureType } from './CashExposureType';
import {
    CashExposureTypeFromJSON,
    CashExposureTypeFromJSONTyped,
    CashExposureTypeToJSON,
} from './CashExposureType';

/**
 * 
 * @export
 * @interface CashAllocation
 */
export interface CashAllocation {
    /**
     * 
     * @type {CashExposureType}
     * @memberof CashAllocation
     */
    exposureType: CashExposureType;
    /**
     * 
     * @type {number}
     * @memberof CashAllocation
     */
    currentExposure: number;
    /**
     * 
     * @type {number}
     * @memberof CashAllocation
     */
    targetExposure: number;
    /**
     * 
     * @type {number}
     * @memberof CashAllocation
     */
    activeExposure: number;
}



/**
 * Check if a given object implements the CashAllocation interface.
 */
export function instanceOfCashAllocation(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "exposureType" in value;
    isInstance = isInstance && "currentExposure" in value;
    isInstance = isInstance && "targetExposure" in value;
    isInstance = isInstance && "activeExposure" in value;

    return isInstance;
}

export function CashAllocationFromJSON(json: any): CashAllocation {
    return CashAllocationFromJSONTyped(json, false);
}

export function CashAllocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): CashAllocation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'exposureType': CashExposureTypeFromJSON(json['exposure_type']),
        'currentExposure': json['current_exposure'],
        'targetExposure': json['target_exposure'],
        'activeExposure': json['active_exposure'],
    };
}

export function CashAllocationToJSON(value?: CashAllocation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'exposure_type': CashExposureTypeToJSON(value.exposureType),
        'current_exposure': value.currentExposure,
        'target_exposure': value.targetExposure,
        'active_exposure': value.activeExposure,
    };
}

